export default "__VITE_ASSET__Ba279sBE__"